import { Match, Show, Switch } from 'solid-js';
import { TextObject } from './text/TextObject';
import { ImageObject } from './images/ImageObject';
import { ContainerObject } from './container/ContainerObject';
import { Mode } from '../project/PosterMode';
import type { RuntimeObject, RuntimeImage, RuntimeText, DataRecord, Position } from '../types';
import type { Canvas } from '../project/posterSchema';
import type { ThemeRecord } from '../project/themeVariables';
import type { ObjectContext } from '../project/objects';
import type { SelectionContext } from './selection';
import type { DragContext } from './drag';
import type { HistoryContext } from '../project/history';
import type { ImageContext } from './images/images';
import type { UploadContext } from './images/upload';
import type { DesignLinkContext } from '../project/designLink';


export interface IRenderContext {
	objects: ObjectContext;
	selection: SelectionContext;
	drag: DragContext;
	history: HistoryContext;
	images: ImageContext;
	/** User-mode link to the nested template design; inert (linked() === false) otherwise. */
	design: DesignLinkContext;
	/** Present only in editable modes; the read-only poster never uploads. */
	upload?: UploadContext;
	record: DataRecord;
	/** Resolved theme variables, threaded alongside the record for bound style/source resolution. */
	theme: ThemeRecord | undefined;
	textRefs: Record<string, SVGTextElement>;
	canvas: Canvas;
	parentOffset?: () => Position;
	parentId?: string | null;
	object: RuntimeObject;
	layoutPos?: () => Position | undefined;
	mode: Mode;
}

export function Object(P: IRenderContext)
{
//XXX BB: why style.isField?
//XXX BB: use of 'keyed' suggests there is always a problem with reactivity somewhere below...

//FIXME the ummm...

	return (
		<Switch>
			<Match when={P.object.type == 'image'}>
				<Show when={(P.object as RuntimeImage).isField ? 'field' : 'plain'} keyed>
					<ImageObject {...P} />
				</Show>
			</Match>

			<Match when={P.object.type == 'text'}>
				<Show when={`${P.mode ?? 'ummm'}:${(P.object as RuntimeText).style?.isField ? 'field' : 'plain'}`} keyed>
					<TextObject {...P} />
				</Show>
			</Match>

			<Match when={P.object.type == 'container'}>
				<ContainerObject {...P} />
			</Match>
		</Switch>
	);
}

